import React, { useEffect, useState } from "react";
import { serverResponse } from "../../../../util/fakeServer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Button, Tooltip } from "reactstrap";
import { addprod } from "../../../../helper/constant";
import { strings } from "../../../../util/data/strings";
import { connect } from "react-redux";
import { isModalOpen } from "../../../../redux/carousel/action";
import { gaEventLabel } from "../../../../settings/gaConfig";
import { closeInteractivityModal } from "../../../../redux/modal/action";
import { addItem } from "../../../../redux/cart/action";
import { sendAnalyticsEvent } from "../../../../helper/utility";

const CartModal = (props) => {
  const [quantity, setQuantity] = useState(
    props.info.quantity_step ? props.info.quantity_step : 1
  );
  const [isOpen, setIsOpen] = useState(false);
  const [minQtyError, setMinQtyError] = useState(props.info.min_order_qty);

  useEffect(() => {
    props.setVarietySelected(
      props.info.varieties.length > 0 ? props.info.varieties[0] : ""
    );
  }, [props.info]);

  const toggleSaveTooltip = () => {
    setIsOpen(!isOpen);
  };

  const qtyInCart = (itemId) => {
    const cartItem = props.cart.find((el) => el.item_id === itemId);

    return cartItem && cartItem !== undefined ? +cartItem.quantity : 0;
  };

  const handleAddProduct = () => {
    let obj = Object.assign({}, props.info);
    if (
      !obj.min_order_qty ||
      (obj.min_order_qty &&
        +quantity + qtyInCart(obj.item_id) >= obj.min_order_qty)
    ) {
      obj.quantity = parseInt(quantity);
      obj.done = false;
      obj.variety = props.varietySelected;
      // props.addProduct(obj);
      props.addItem(obj);
      props.closeInteractivityModal();
      if (document.getElementById("selected-" + props.id) != null)
        document.getElementById("selected-" + props.info.item_id).style[
          "display"
        ] = "inline";
      sendAnalyticsEvent(
        gaEventLabel.add_to_grocery_list,
        String(props.info.item_id)
      );
    } else {
      setMinQtyError(obj.min_order_qty);
    }
  };

  const handleQuantityInput = (e) => {
    if (e.target.value && e.target.value !== "0") {
      setQuantity(e.target.value);
    } else {
      setQuantity(1);
    }
  };

  return (
    <div className="row" style={{ marginTop: "30px" }}>
      <div className="col-12">
        <div
          className="container-add-to-list"
          style={{ justifyContent: "space-between" }}
        >
          {!props.info.one_and_one_gratis && (
            <div>
              <div className="container-add-to-list">
                <input
                  style={{
                    textAlign: "right",
                    paddingRight: "7px"
                  }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="1"
                  defaultValue={1}
                  onChange={handleQuantityInput}
                  type="text"
                  autoFocus={true}
                />
                <h6 style={{ fontWeight: "bold" }}>
                  {props.info.grocery_label}
                </h6>
              </div>
              {minQtyError && (
                <p className="text-danger" style={{ fontSize: ".8rem" }}>
                  Quantità minima ordinabile {minQtyError}{" "}
                  {props.info.grocery_label}
                </p>
              )}
            </div>
          )}

          {!props.info.one_and_one_gratis && (
            <div className="container-add-to-list">
              <Button
                id={"btnSave_" + props.info.item_id}
                disabled={
                  props.info.stock !== "y" &&
                  props.info.stock !== null &&
                  serverResponse.config.manager_stock
                }
                color="primary"
                onClick={handleAddProduct}
              >
                {!serverResponse.config.send_grocery_list_to_market && (
                  <img
                    src={addprod}
                    style={{
                      color: "#00ff00",
                      width: "30px",
                      cursor: "pointer"
                    }}
                    alt="img"
                  />
                )}
                {serverResponse.config.send_grocery_list_to_market && (
                  <FontAwesomeIcon
                    icon={faShoppingCart}
                    style={{ fontSize: "35px" }}
                  />
                )}
              </Button>
              {props.info.stock === "t" && (
                <Tooltip
                  placement="top"
                  isOpen={this.state.saveTooltipOpen}
                  target={"btnSave_" + props.info.item_id}
                  toggle={toggleSaveTooltip}
                >
                  {strings.saveBtnTooltip}
                </Tooltip>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cartReducer.cart
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addItem: (item) => {
      dispatch(addItem(item));
    },
    isModalOpen: (bool) => {
      dispatch(isModalOpen(bool));
    },
    closeInteractivityModal: () => {
      dispatch(closeInteractivityModal());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartModal);
